import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CTASection from "@/components/CTASection";
import { Shield, Award, MapPin } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-primary py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
              About Big Bear's Pro Floors
            </h1>
            <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto">
              Owner-operated flooring professionals serving Colorado Springs with pride.
            </p>
          </div>
        </section>

        {/* About Content */}
        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="prose prose-lg mx-auto">
                <div className="bg-card rounded-lg p-8 shadow-md mb-12">
                  <h2 className="font-heading font-bold text-2xl mb-4 text-foreground">Built Solid. Finished Right.</h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    Big Bear's Pro Floors is an owner-operated flooring company serving Colorado Springs and the surrounding areas. We take pride in delivering quality craftsmanship on every project, from small repairs to complete floor transformations.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    When you work with Big Bear's Pro Floors, you work directly with the owner. This means personalized service, clear communication, and a commitment to getting the job done right the first time.
                  </p>
                </div>

                {/* Values */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="text-center p-6 bg-muted rounded-lg">
                    <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Shield className="w-8 h-8 text-accent" />
                    </div>
                    <h3 className="font-heading font-bold text-lg mb-2">Quality First</h3>
                    <p className="text-muted-foreground text-sm">
                      We never cut corners. Every floor we install is built to last for generations.
                    </p>
                  </div>

                  <div className="text-center p-6 bg-muted rounded-lg">
                    <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Award className="w-8 h-8 text-accent" />
                    </div>
                    <h3 className="font-heading font-bold text-lg mb-2">Owner-Operated</h3>
                    <p className="text-muted-foreground text-sm">
                      Work directly with the owner from estimate to completion. No middlemen, no surprises.
                    </p>
                  </div>

                  <div className="text-center p-6 bg-muted rounded-lg">
                    <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <MapPin className="w-8 h-8 text-accent" />
                    </div>
                    <h3 className="font-heading font-bold text-lg mb-2">Local Service</h3>
                    <p className="text-muted-foreground text-sm">
                      Proudly serving Colorado Springs and surrounding communities with professional flooring services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default About;
